import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VueYoutube from 'vue-youtube'
import draggable from 'vuedraggable'
import AOS from 'aos'

import 'aos/dist/aos.css' // You can also use <link> for styles

Vue.use(draggable)
Vue.use(VueYoutube)
Vue.use(AOS)
// Importar y registrar componentes

import audioPlayer from '@/components/audio-player'
Vue.component("audio-player", audioPlayer);
import botonCerrarModal from '@/components/boton-cerrar-modal'
Vue.component("boton-cerrar-modal-app", botonCerrarModal);
import header from '@/components/header'
Vue.component("header-app", header);
import dialogos from '@/components/dialogos'
Vue.component("dialogos-app", dialogos)
import navMenu from '@/components/nav-menu'
Vue.component("nav-menu-app", navMenu)
import modalApp from '@/components/modal'
Vue.component("modal-app", modalApp)
import youtubeVideoApp from '@/components/youtube-video'
Vue.component("youtube-video-app", youtubeVideoApp)
import slideItemsApp from '@/components/slide-items'
Vue.component("slide-items-app", slideItemsApp)
import dropGingaApp from '@/components/drop-ginga'
Vue.component("drop-ginga-app", dropGingaApp)
import logosApp from '@/components/logos'
Vue.component("logos-app", logosApp)
import carrouselimgApp from '@/components/carrouselimg'
Vue.component("carrouselimg-app", carrouselimgApp)
import tarjetaGiratoria from '@/components/tarjeta-giratoria'
Vue.component("tarjeta-giratoria-app", tarjetaGiratoria)
import slidergaleriaApp from '@/components/slider-galeria'
Vue.component("slidergaleria-app", slidergaleriaApp)
import scrollDownApp from '@/components/scroll-down'
Vue.component("scrolldown-app", scrollDownApp)

Vue.config.productionTip = false
AOS.init();
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({
      behavior: "smooth"
    })
  },
  componentUpdated: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({
      behavior: "smooth"
    })
  }
})
new Vue({
  router,
  store,
  AOS,
  render: h => h(App)
}).$mount('#app')